import { render } from "./Footer.vue?vue&type=template&id=56e69388&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=56e69388&scoped=true&lang=css"

import exportComponent from "E:\\amapa-lp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e69388"]])

export default __exports__